import { createPortal } from 'react-dom';
import { useEffect, useImperativeHandle, useRef, useState } from "react"

import { useTableStore } from '../../_stores';

import Cell from './_Cell';

const DropdownEditCell = ({ data, column }, ref) => {
	const onDropdownClick = useTableStore(state => state.onDropdownClick)
	const onDropdownOpen = useTableStore(state => state.onDropdownOpen)

	// local
	const [mainDropdownData, setMainDropdownData] = useState([])
	const [dropdownData, setDropdownData] = useState([])
	const [isDropdownOpen, setIsDropdownOpen] = useState(false)
	const [emptyText, setEmptyText] = useState("Please save a category/subcategory")

	useEffect(() => {
		setDropdownData(mainDropdownData)
	}, [mainDropdownData])

	useEffect(() => {
		if (column.static) {
			setMainDropdownData(column.dropdownData)
		}
	}, [column.static])

	useEffect(() => {
		if (isDropdownOpen) {
			document.addEventListener('click', handleOutsideClick)
			// on dropdown open
			onDropdownOpen && onDropdownOpen({
				column: column,
				cell: ref.current,
				row: ref.current.closest('tr'),
			})
		} else
			document.removeEventListener('click', handleOutsideClick)


		return () => {
			document.removeEventListener('click', handleOutsideClick)
		}
	}, [isDropdownOpen])

	const handleOutsideClick = (e) => {
		if (e.target === ref.current.querySelector('div[contenteditable]') || e.target.closest('.table-dropdown') || e.target.closest('.table-edit-icon')) return
		setIsDropdownOpen(false)
	}

	const handleDropdownItemClick = (text, value) => {
		// empty the cell
		ref.current.querySelector('div[contenteditable]').textContent = ""
		ref.current.querySelector('div[contenteditable]').setAttribute('placeholder', text)
		ref.current.querySelector('div[contenteditable]').setAttribute('data-value', value)

		setIsDropdownOpen(false)
		onDropdownClick && onDropdownClick({
			text: text,
			value: value,
			column: column,
			cell: ref.current,
			row: ref.current.closest('tr'),
		})
	}

	const searchDropdown = (e) => {
		const dropdownDataFiltered = mainDropdownData.filter((item) => {
			return item.text.toLowerCase().includes(e.target.textContent.toLowerCase())
		})

		// set dropdown data
		setDropdownData(dropdownDataFiltered)

		if (dropdownDataFiltered.length === 0) {
			setEmptyText("No results found")
		} else {
			setEmptyText("Please save a category/subcategory")
		}

		if (e.target.textContent === "") {
			setEmptyText("Please save a category/subcategory")
		}
	}

	return (
		<>
			<Cell
				ref={ref}
				data={data}
				setDropdownData={setMainDropdownData}
				column={column}
				setIsDropdownOpen={setIsDropdownOpen}
				editDivInputHandler={searchDropdown}
			/>

			{isDropdownOpen && createPortal(<Dropdown emptyText={emptyText} data={dropdownData} handleItemClick={handleDropdownItemClick} dimensions={ref.current.querySelector('div[contenteditable]').getBoundingClientRect()} />, document.body)}
		</>
	)
}

const Dropdown = ({ data, dimensions, handleItemClick, emptyText }) => {
	const dropdownRef = useRef(null)
	// on mount
	useEffect(() => {
		// set position
		dropdownRef.current.style.top = dimensions.top + dimensions.height + 'px'
		dropdownRef.current.style.left = dimensions.left + 'px'

		// min width
		dropdownRef.current.style.minWidth = `${dimensions.width + 4}px`
	}, [data])

	return (
		<div ref={dropdownRef} className='table-dropdown absolute max-w-[400px] text-black text-start text-placeholder p-2 bg-white rounded-primary flex flex-col
		shadow-md border border-gray-300 z-10
		animate__animated animate__fadeIn animate__faster mt-2 -ml-0.5
		'>
			<div className='max-h-[400px] overflow-y-auto pr-2'>
				{data.length > 0 && data.map((item, index) => {
					return <div key={index} value={item.value} onClick={() => {
						handleItemClick(item.text, item.value)
					}}
						className='p-2 rounded-primary hover:bg-primary-100 hover:cursor-pointer transition-all'
					>{item.text}</div>
				})}
				{!data || data.length === 0 && <div className='p-2 rounded-primary'>
					{`${emptyText}`}</div>}
			</div>
		</div>
	)
}

export default React.forwardRef(DropdownEditCell)